import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rmt-rate-selector',
  templateUrl: 'rmt-rate-selector.html'
})
export class RmtRateSelectorComponent {
  @Input() rates;
  @Input() selected;
  @Output() selectedChange = new EventEmitter();

  constructor() {
  }

  setSelected(index) {
    this.selectedChange.emit(index);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-rate-selector/rmt-rate-selector.ts